export default new Set([
    "email",
    "password",
])